<template>
  <div class="news">
    <div class="news-header">
      <img class="hidden-lg-and-down" src="../../assets/image/news/News_Center.png" alt="">
      <img class="hidden-xl-only hidden-lg-only hidden-md-and-down" src="../../assets/image/news/News_Center_md.png" alt="">
      <img class="hidden-xl-only hidden-lg-only hidden-xs-only" src="../../assets/image/news/News_Center_sm.png" alt="">
      <img class="hidden-xl-only hidden-lg-only hidden-md-only hidden-sm-only" src="../../assets/image/news/News_Center_xs.png" alt="">
      <span class="news-title">新闻中心</span>
    </div>
    <div class="news-content">
      <ul class="flex-align-center flex-center news-tabs-title">
        <li v-for="(item, index) in newsTitle" :key="index" @click="getNewData(item,1)" :class="item == queryParams.type ? active :'news-tabs-item'">{{item}}</li>
      </ul>
      <ul class="news-list">
<!--        <li class="news-item" v-for="(item, index) in newsList" :key="index">-->
<!--          <template v-if="item.type == queryParams.type">-->
            <el-row :gutter="gutter">
<!--              <el-col class="news-item-list" :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-for="(news, index) in newsList[index].rNewsList" :key="index">-->
              <el-col class="news-item-list" :xs="24" :sm="12" :md="8" :lg="8" :xl="8" v-for="(news, index) in newsList" :key="index">
                <a :href="news.linkUrl" target="_blank" rel="noopener noreferrer">
                  <el-skeleton :loading="loading" animated>
                    <template slot="template">
                      <el-skeleton-item variant="image" style="width: 100%; height: 240px;"/>
                    </template>
                    <template>
                      <div class="news-item-box">
                        <div class="news-item-img">
<!--                          <el-image-->
<!--                            lazy-->
<!--                            :src= "news.imgUrl"-->
<!--                            :onerror="require('../../assets/image/loadimg/news_img03.jpg')"-->
<!--                            alt="">-->
<!--                            <div slot="placeholder" class="image-slot">-->
                              <img :src="news.imgUrl" alt="">
<!--                            </div>-->
<!--                          </el-image>-->
                        </div>
                        <div class="news-item-content">
                          <div class="news-item-title" :class="news.clas">{{news.title}}</div>
                          <p class="news-item-time">{{news.setTime}}</p>
                        </div>
                      </div>
                    </template>
                  </el-skeleton>
                </a>
              </el-col>
            </el-row>
<!--          </template>-->
<!--        </li>-->
      </ul>
      <div class="pagination hidden-xs-only">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :page-size="6"
          layout="prev, pager, next"
          :total=total
          v-show="total>0"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../assets/js/api'
// import api from '../../assets/js/api_data'
export default {
  data() {
    return {
      loading: false,
      screenWidth: document.body.clientWidth,
      gutter: 24,
      total: 0,
      active: 'active-item news-tabs-item',
      newsTitle: [],
      newsList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 6,
        type: '优惠活动',
      }
    }
  },
  created() {
    this.getNewType()
    this.getNewData(this.queryParams.type,this.queryParams.pageNum)
  },
  mounted() {
    this.total = this.total
    this.getScreenWidth(this.screenWidth)
    const that = this
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth
        that.screenWidth = window.screenWidth
      })()
    }
  },
  methods: {
    handleCurrentChange(val){
      this.getNewData(this.queryParams.type,val)
    },
    getNewType(){
      api.getNewType()
        .then((res) => {
          this.newsTitle = res.data
        })
    },
    getScreenWidth (val) {
      if ( val > 993 && val < 1200) {
        this.gutter = 18
      }
      if ( val > 767 && val < 993) {
        this.gutter = 15
      }
      if (val < 767) {
        this.gutter = 0
      }
    },
    getNewData (index,val) {
      this.loading = true
      this.queryParams.type = index
      this.queryParams.pageNum = val
      let params = 'pageNum='+this.queryParams.pageNum+'&pageSize='+this.queryParams.pageSize+'&type='+this.queryParams.type
      api.getNewData(params)
        .then((res) => {
          this.newsList = res.rows
          this.total = res.total
          this.loading = false
        })
    }
  },
  watch: {
    screenWidth (val) {
      this.getScreenWidth(val)
    }
  },
}
</script>
